import { API_URL }  from "../constants.js";
import axios from 'axios';
import middleware from '../util/middleware';

var request = axios.create({
    baseURL: API_URL,
    headers: {
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
        'Content-Type':'application/json'
    }
})

/**
 * Clase para ver el request de catálogos
 */
class CatalogosRequest {

    /**
     * Llamada el endpoint de django para obtener las regiones
     * en la BD
     * @param: nada
     * @return: Una lista de regiones.
     */
    static ListarRegiones() {
        return middleware.hasAuth(() => request.get(`api/regiones/`))
    }

    /**
     * Llamada el endpoint de django para obtener las sucursales
     * en la BD
     * @param: nada
     * @return: Una lista de sucursales.
     */
    static ListarSucursales() {
        return middleware.hasAuth(() => request.get(`api/sucursales/`))
    }

    /**
     * Llamada el endpoint de django para obtener las sucursales por region
     * en la BD
     * @param: value. id de región
     * @return: Una lista de sucursales.
     */
    static ListarSucursalesRegion(value) {
        return middleware.hasAuth(() => request.get(`api/sucursales/region/${value}/`))
    }

    /**
     * Llamada el endpoint de django para obtener las plazas
     * en la BD
     * @param: nada
     * @return: Una lista de plazas.
     */
    static ListarPlazas() {
        return middleware.hasAuth(() => request.get(`api/plazas/`))
    }

    /**
     * Llamada el endpoint de django para obtener las plazas por sucursal
     * en la BD
     * @param: value
     * @return: Una lista de plazas.
     */
    static ListarPlazasSucursal(value) {
        return middleware.hasAuth(() => request.get(`api/plazas/${value}/`))
    }

    /**
     * Llamada el endpoint de django para obtener los sitios
     * en la BD
     * @param: nada
     * @return: Una lista de sitios.
     */
    static ListarSitios(value, segmento) {
        let plazas = '';
        if (Array.isArray(value)) {
            plazas = value.flat().filter(x => x !== null).join(',');
        } else {
            plazas = value;
        }
        return middleware.hasAuth(() => request.get(`api/sitios/`, {
            params: {
                plazas_id: plazas,
                segmento: segmento,
                page_size: 0
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener los sitios
     * de la plaza y usuario
     * @param: nada
     * @return: Una lista de sitios.
     */
    static ListarSitiosPlazaUsuario(value, value1) {
        return middleware.hasAuth(() => request.get(`api/sitios-usuario/`, {
            params: {
                plaza_id: value,
                usuario_id: value1,
                page_size: 0
            }
        }))
    }

    /**
     * Llamada el endpoint de django para obtener los supervisores
     * en la BD
     * @param: nada
     * @return: Una lista de supervisores.
     */
    static ListarSupervisoresPlaza(value, value1) {
        return middleware.hasAuth(() => request.get(`api/usuarios/?plaza=${value}&supervisores=${value1}&page_size=0`))
    }

    /**
     * Llamada el endpoint de django para obtener los estatus
     * en la BD
     * @param: value
     * @return: Una lista de estatus.
     */
    static ListarEstatus() {
        return middleware.hasAuth(() => request.get(`api/estatus/`))
    }

     /**
     * Llamada el endpoint de django para obtener los
     * tipos de modelos en la BD
     * @param: value
     * @return: Una lista de tipos de modelos.
     */
    static ListarTiposModelos() {
        return middleware.hasAuth(() => request.get(`api/tipo-modelo/`))
    }

    /**
     * Llamada el endpoint de django para obtener los
     * días de pedido en la BD
     * @param: value
     * @return: Una lista de días de pedido.
     */
    static ListarDiasPedido() {
        return middleware.hasAuth(() => request.get(`api/dias-pedido/`))
    }

    /**
     * Llamada el endpoint de django para obtener los roles
     * en la BD
     * @param: nada
     * @return: Una lista de roles.
     */
    static ListarRoles() {
        return middleware.hasAuth(() => request.get(`api/roles/`))
    }

    /**
     * Llamada el endpoint de django para obtener las máquinas
     * en la BD de mic
     * @param: nada
     * @return: Una lista de máquinas.
     */
    static ListarMaquinas() {
        return middleware.hasAuth(() => request.get(`api/maquinas/`))
    }

    /**
     * Llamada el endpoint de django para obtener los tipos de notificaciones
     * en la BD
     * @param: value
     * @return: Una lista de tipos de notificaciones.
     */
    static ListarTipoNotificaciones(value) {
        return middleware.hasAuth(() => request.get(`api/tipo/notificaciones`))
    }

    /**
     * Llamada el endpoint de django para obtener los centros suministradores de UPA
     * en la BD
     * @param: value
     * @return: Una lista de los centros suministradores UPA.
     */
    static ListarCentroSuministrador(value) {
        return middleware.hasAuth(() => request.get(`api/centro/suministrador/`))
    }

    /**
     * Llamada el endpoint para obtener los segmentos configurados
     * en la BD
     * @param: value
     * @return: Una lista de los segmentos configurados
     */
    static ListarSegmentosConfigurados(value) {
        return middleware.hasAuth(() => request.get(`api/segmentos-punto-venta-configurados`))
    }
}

export default CatalogosRequest;